import React from 'react';
import './Button.css';

const button = (props) => {
    let classType = "pure-button";
    let style = {}
    classType = props.type ? props.type + " " + classType : classType;


    style = props.style ? props.style : {}

    return (
        <button onClick={props.onClick ? props.onClick() : () => { }} className={classType} style={style}>
            <i className={props.icon}></i>
            <span className="tool" data-tip={props.buttonName} />
            {" " + props.buttonName}
        </button>
    )
}


export default button;